import React, { FC } from 'react';

import { Text } from '@chakra-ui/react';

interface ITextHeader {}

export const TextHeader: FC<ITextHeader> = props => {
  return <Text fontWeight={700}>{props.children}</Text>;
};
